export const KITCHEN_EQUIPMENT = [
  // Basis kookgerei
  'Koekenpan',
  'Sauspan',
  'Braadpan',
  'Wok',
  'Steelpan',
  'Stockpot',
  
  // Ovengerei
  'Ovenschaal',
  'Bakplaat',
  'Bakvorm',
  'Springvorm',
  'Muffinvorm',
  'Pizzasteen',
  
  // Keukenapparatuur
  'Oven',
  'Magnetron',
  'Blender',
  'Keukenmachine',
  'Mixer',
  'Staafmixer',
  'Broodrooster',
  'Grill',
  'Airfryer',
  'Slowcooker',
  'Rijstkoker',
  'Stoomoven',
  
  // Snij- en bereidingstools
  'Snijplank',
  'Koksmes',
  'Puntmes',
  'Broodmes',
  'Schilmesje',
  'Keukenschaar',
  'Rasp',
  'Mandoline',
  'Garlic press',
  
  // Meet- en menggereedschap
  'Maatbeker',
  'Keukenweegschaal',
  'Maatlepels',
  'Mengkom',
  'Garde',
  'Spatel',
  'Pollepel',
  'Scheplepel',
  'Tang',
  
  // Zeef en vergiet
  'Zeef',
  'Vergiet',
  'Fijnmazige zeef',
  
  // Speciale tools
  'Deegroller',
  'Pastamachine',
  'Mortiertje',
  'Citruspers',
  'Aardappelstamper',
  'IJscrème machine',
  'Thermometer',
  'Timer',
] as const

export type KitchenEquipment = typeof KITCHEN_EQUIPMENT[number]

export function getEquipmentIcon(equipment: string): string {
  const iconMap: Record<string, string> = {
    'Koekenpan': '🍳',
    'Sauspan': '🥘',
    'Oven': '🔥',
    'Magnetron': '📱',
    'Blender': '🌪️',
    'Mixer': '🥄',
    'Snijplank': '🪵',
    'Koksmes': '🔪',
    'Maatbeker': '🥛',
    'Keukenweegschaal': '⚖️',
    'Mengkom': '🥣',
    'Zeef': '🕳️',
    'Vergiet': '🕳️',
    'Deegroller': '🥖',
    'Timer': '⏲️',
  }
  
  return iconMap[equipment] || '🔧'
}